import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { TriangleAlert } from 'lucide-react';

interface UnsavedChangesPopupProps {
  open?: boolean;
  onDiscard: () => void;
  onCancel: () => void;
  title?: string;
  body?: string;
  discardLabel?: string;
  cancelLabel?: string;
}

export function UnsavedChangesPopup({
  open = false,
  onDiscard,
  onCancel,
  title,
  body,
  cancelLabel,
  discardLabel,
}: UnsavedChangesPopupProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent
        data-testid="unsaved-changes-dialog"
        className="bg-card"
      >
        <AlertDialogHeader>
          <div className="flex gap-2 items-center">
            <div className="p-1.5 flex-shrink-0 bg-status-warn-emphasis/30 rounded-full flex items-center justify-center">
              <TriangleAlert className="h-4 w-4 text-status-warn-emphasis" />
            </div>
            <AlertDialogTitle>
              {title || 'Discard unsaved changes?'}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            {body ||
              'You have unsaved changes. If you leave now, your changes will be lost.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-4">
          <AlertDialogCancel
            data-testid="unsaved-changes-discard"
            onClick={onDiscard}
          >
            {discardLabel || 'Discard Changes'}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="unsaved-changes-stay"
            onClick={onCancel}
          >
            {cancelLabel || 'Stay on Page'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
